module.exports = __webpack_public_path__ + "img/vertical_6_4_8004.37e37656.png";